const vAdminTheme = () => {

    const themeBtn = document.querySelectorAll('.vjs-theme-toggle');

    if ( !themeBtn ) {
        return false;
    }

    const { body } = document;
    const themeState = window.localStorage.getItem('theme');

    if ( themeState == 'dark' ) {
        showDarkTheme();
    }

    const toggleTheme = () => {

        if ( body.classList.contains('v-theme--dark') ) {
            showLightTheme();
        } else {
            showDarkTheme();
        }
    }

    function showLightTheme() {
        body.classList.remove('v-theme--dark');
        window.localStorage.setItem('theme', 'light');
    }

    function showDarkTheme() {
        body.classList.add('v-theme--dark');
        window.localStorage.setItem('theme', 'dark');
    }

    [...themeBtn].forEach(btn => {
        btn.addEventListener('click', toggleTheme)
    })
}

export default vAdminTheme;
